import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-player-card-dialog',
  standalone: true,
  imports: [TranslocoPipe,MatIconModule],
  templateUrl: './player-card-dialog.component.html',
  styleUrl: './player-card-dialog.component.scss'
})
export class PlayerCardDialogComponent {


  private matDialog = inject(MatDialogRef<PlayerCardDialogComponent>);
  player : any;
  financialData: any;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: { player: any; financialData: any }) { 
    this.player = data.player;
    this.financialData = data.financialData;
  }

  close(){
    this.matDialog.close();
  }
}
